import React from 'react';

import StatusPage from '../../components/StatusPage';
import messages from './messages';

const UnsubscribeSuccess = ({ children }: { children: React.ReactNode }) => (
  <StatusPage
    variant="success"
    pageName="unsubscribe-success"
    messages={messages}
    actions={[
      { to: '/contact', label: messages.contactSupport, variant: 'primary' },
      { to: '/', label: messages.returnHome, variant: 'secondary' },
    ]}
  >
    {children}
  </StatusPage>
);

export default UnsubscribeSuccess;
